import * as S from './index.style'
import { Row, Spin } from 'antd'
import { SyncOutlined } from '@ant-design/icons'

export const Overlay = ({
  isLoading = false,
  children,
}: {
  isLoading: boolean
  children: JSX.Element | JSX.Element[]
}) => {
  return (
    <>
      {isLoading && (
        <S.Container loading={isLoading.toString()}>
          <Row
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
            }}
          >
            <Spin indicator={<SyncOutlined style={{ fontSize: 128, color: 'white' }} spin />} />
          </Row>
        </S.Container>
      )}
      {children}
    </>
  )
}
